import React from 'react';
import PropTypes from 'prop-types';
import {
  ItemGroup,
  Item,
  Label,
  SelectedCount,
  Title,
  Divider,
} from './Compounds';

import { st, classes } from './TableToolbar.st.css';

const TableToolbar = ({
  dataHook,
  className,
  removeVerticalPadding,
  children,
}) => (
  <div
    data-hook={dataHook}
    className={st(
      classes.root,
      {
        removeVerticalPadding,
      },
      className,
    )}
  >
    {children}
  </div>
);

TableToolbar.propTypes = {
  /** Applies a CSS class to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook: PropTypes.string,
  /** Removes vertical paddings from the component */
  removeVerticalPadding: PropTypes.bool,
};

TableToolbar.ItemGroup = ItemGroup;
TableToolbar.Item = Item;
TableToolbar.Label = Label;
TableToolbar.SelectedCount = SelectedCount;
TableToolbar.Title = Title;
TableToolbar.Divider = Divider;
TableToolbar.displayName = 'TableToolbar';

export default TableToolbar;
